module.exports = __webpack_public_path__ + "static/media/FloOptimized.69929c88.jp2";